var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 133,
    viewBox: "0 0 131 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 44,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#F8F2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29890_73243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.025 57.7125V58.95H67.975V57.7125C67.975 57.0551 68.5164 56.475 69.2125 56.475C69.8699 56.475 70.45 57.0551 70.45 57.7125V58.95H72.3062C73.3117 58.95 74.1625 59.8008 74.1625 60.8063V62.6625H56.8375V60.8063C56.8375 59.8008 57.6496 58.95 58.6938 58.95H60.55V57.7125C60.55 57.0551 61.0914 56.475 61.7875 56.475C62.4449 56.475 63.025 57.0551 63.025 57.7125ZM56.8375 63.9H74.1625V74.4188C74.1625 75.4629 73.3117 76.275 72.3062 76.275H58.6938C57.6496 76.275 56.8375 75.4629 56.8375 74.4188V63.9ZM59.3125 68.2313C59.3125 68.5793 59.5832 68.85 59.9313 68.85H61.1688C61.4781 68.85 61.7875 68.5793 61.7875 68.2313V66.9938C61.7875 66.6844 61.4781 66.375 61.1688 66.375H59.9313C59.5832 66.375 59.3125 66.6844 59.3125 66.9938V68.2313ZM64.2625 68.2313C64.2625 68.5793 64.5332 68.85 64.8813 68.85H66.1188C66.4281 68.85 66.7375 68.5793 66.7375 68.2313V66.9938C66.7375 66.6844 66.4281 66.375 66.1188 66.375H64.8813C64.5332 66.375 64.2625 66.6844 64.2625 66.9938V68.2313ZM69.8313 66.375C69.4832 66.375 69.2125 66.6844 69.2125 66.9938V68.2313C69.2125 68.5793 69.4832 68.85 69.8313 68.85H71.0688C71.3781 68.85 71.6875 68.5793 71.6875 68.2313V66.9938C71.6875 66.6844 71.3781 66.375 71.0688 66.375H69.8313ZM59.3125 73.1813C59.3125 73.5293 59.5832 73.8 59.9313 73.8H61.1688C61.4781 73.8 61.7875 73.5293 61.7875 73.1813V71.9438C61.7875 71.6344 61.4781 71.325 61.1688 71.325H59.9313C59.5832 71.325 59.3125 71.6344 59.3125 71.9438V73.1813ZM64.8813 71.325C64.5332 71.325 64.2625 71.6344 64.2625 71.9438V73.1813C64.2625 73.5293 64.5332 73.8 64.8813 73.8H66.1188C66.4281 73.8 66.7375 73.5293 66.7375 73.1813V71.9438C66.7375 71.6344 66.4281 71.325 66.1188 71.325H64.8813ZM69.2125 73.1813C69.2125 73.5293 69.4832 73.8 69.8313 73.8H71.0688C71.3781 73.8 71.6875 73.5293 71.6875 73.1813V71.9438C71.6875 71.6344 71.3781 71.325 71.0688 71.325H69.8313C69.4832 71.325 69.2125 71.6344 69.2125 71.9438V73.1813Z",
    fill: "#A0438B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29890_73243",
    x: 0.585938,
    y: 0.225098,
    width: 129.828,
    height: 132.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29890_73243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29890_73243",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPink);
export default __webpack_public_path__ + "static/media/calendar-pink.fb0a164b.svg";
export { ForwardRef as ReactComponent };